<template>
  <div class="list" style="width:100%">
    <Header :title="$t('m.MeetingTemplateList')"></Header>
    <div class="top_Bar">
      <span class="serchbox">
        <Icon type="ios-search"></Icon>
        <input
          @input="getMeetingTemplateList"
          class="searchinput"
          :placeholder="$t('m.PlsEnterMeetingTemplateName')"
          type="text"
          v-model="searchContent"
        />
      </span>
    </div>
    <div class="contentitem grebgc">
      <div class="itemlist spebgc" :style="{'height': tableHeight+'px'}">
        <p :key="index" v-for="(item,index) in meetingtemplate">
          <span @click="edittemplate(item.id)">{{item.meeting_templatename}}</span>
          <span class="right img">
            <Icon
              color="red"
              @click="deleteTemplate(item.meeting_templatename,item.id)"
              type="md-close-circle"
            />
          </span>
        </p>
      </div>
      <Page
        v-show="dataCount>0"
        ref="pages"
        class="page_bottom"
        :current.sync="currentPage"
        :total="dataCount"
        simple
        :page-size="pageSize"
        @on-change="chagePage"
      />
    </div>
    <div class="pop" v-if="exitdansure">
      <div class="templatepopexit">
        <div class="popclosex" @click="exitdansure=false">
          <Icon type="ios-close"></Icon>
        </div>
        <div class="title-line">
          <img class="iconimg" :src="confirmUrl" />
          <span class="title_sure">{{$t('m.DeleteConfirmation')}}</span>
        </div>
        <div class="templatepoptop">{{$t('m.YouConfirmaDelete')}}{{templateName}}{{$t('m.Template')}}</div>
        <div @click="exitdansure=false" class="templatepopbottomexit color bdc">{{$t('m.CancelBtn')}}</div>
        <div @click="deleteTemplateSure" class="templatepopbottomexit bgc">{{$t('m.OKBtn')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../../header/header";
import {
  deleteMeetingTemplate,
  getMeetingTemplateList
} from "../../../assets/js/url";

export default {
  data() {
    return {
      searchContent: '',
      templateName: "",
      templateId: "",
      exitdansure: false,
      confirmUrl: require("@/assets/images/public/confirm.png"),
      meeting: [],
      meetingtemplate: [],
      star: 0,
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      tableHeight: document.documentElement.clientHeight - 135
    };
  },
  components: {
    Header
  },
  activated() {
    this.start = 0;
    this.$nextTick(function() {
      this.$refs["pages"].currentPage = 1;
    });
    this.getMeetingTemplateList();
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    }
  },
  methods: {
    edittemplate(id) {
      this.$router.push({
        path: "/meetingtemplateedit",
        query: { meeting_templateid: id, isTrue: true }
      });
    },
    deleteTemplate(templateName, templateId) {
      this.templateName = templateName;
      this.templateId = templateId;
      this.exitdansure = true;
    },
    deleteTemplateSure() {
      this.$loadingshow();
      this.$http
        .post(deleteMeetingTemplate, {
          id: this.templateId
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            this.exitdansure = false;
            this.getMeetingTemplateList();
            _this.$router.go(0);
          } else {
            this.$toast(this.$t('m.DeleteMeetingTemplateFail'));
          }
        });
    },
    getMeetingTemplateList() {
      this.$loadingshow();
      this.$http
        .post(getMeetingTemplateList, {
          useruuid: window.sessionStorage.getItem("UUID"),
          start: this.star,
          pagesize: 10,
          meeting_templatename: this.searchContent
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            this.meetingtemplate = res.data.data;
            this.dataCount = res.data.total;
          } else {
            this.$toast(this.$t('m.MeetingListGetError'));
          }
        });
    },
    chagePage(index) {
      this.start = (index - 1) * 10;
      this.getMeetingTemplateList();
    },
    tomeetingdetail(item) {
      this.$router.push({
        name: "meetingdetail",
        query: {
          meetinguuid: item
        }
      });
    }
  }
};
</script>
<style scoped>
.top_Bar {
  width: 100%;
  border-bottom: 1px solid #f2f1f1;
  display: flex;
  justify-content: space-between;
  padding: 5px 15px;
  line-height: 32px;
  background-color: #fff;
  z-index: 10;
  margin-bottom: 5px;
}
.top_Bar_wechat {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  line-height: 32px;
  background-color: #fff;
  z-index: 10;
}
.serchbox {
  width: 1.9rem;
  height: 0.32rem;
  line-height: 0.32rem;
  display: inline-block;
  border-radius: 5px;
  border: 1px solid #fff;
  /* float: left; */
  margin-right: 0.1rem;
  box-sizing: border-box;
  padding: 0 0.1rem;
}

.searchinput {
  width: 1.2rem;
  height: 0.32rem;
  border: none;
  background-color: transparent;
  outline: none;
  line-height: 0.32rem;
}
.itemlist p {
  padding: 0 0.15rem;
  height: 0.41rem;
  line-height: 0.41rem;
  font-size: 0.14rem;
}

.itemlist p:nth-child(2n) {
  background-color: rgba(0, 0, 0, 0.1);
}

.right {
  float: right;
  height: 0.41rem;
  line-height: 0.41rem;
  font-size: 0.14rem;
  text-decoration: none !important;
}

.right img {
  width: 0.18rem;
  height: 0.18rem;
  vertical-align: middle;
  margin-left: 0.2rem;
}

.width {
  display: inline-block;
  width: 49%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: underline;
}

.time,
.relativetime {
  display: inline-block;
}

.time {
  width: 60%;
  text-align: center;
}

.relativetime {
  width: 40%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/content/indextomeeting/meetingtemplate.vue